<bmcore-cookie-policy-page [colorSettingsMode]="colorSettingsMode"> </bmcore-cookie-policy-page>
